import React from "react";

export function MessageComponent({ display, message, type }) {
  const color = type === "error" ? "bg-red-100 border-red-400 text-red-700" : "bg-green-100 border-green-400 text-green-700";

  return (
    <>
      {display &&
        <div className={`border-t border-b px-4 py-3 mb-6 ${color}`} role="alert">
          <p className="font-bold">Attention</p>
          <p>{message}</p>
        </div>
      }
    </>
  )
}